import { AlertColor, SnackbarOrigin } from '@mui/material'
import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import * as services from '@services/common.services'
import { COMMON_ACTION_TYPE } from './types'

export type toastParams = {
  message: string
  severity?: AlertColor
  anchorOrigin?: SnackbarOrigin
  autoHideDuration?: number | null
}

export type routeParams = {
  path: string | undefined
}

export const addToast = createAction<toastParams>('toast/addToast')
export const removeToast = createAction<string>('toast/removeToast')
export const cleanToasts = createAction('toast/cleanToasts')
export const helperHide = createAction('helper/helperHide')
export const helperShow = createAction('helper/helperShow')
export const previousRoute = createAction<routeParams>('route/saveRoute')

export const appInit = createAsyncThunk<services.AppInitResponse>(
  COMMON_ACTION_TYPE.INIT,
  async (_, { rejectWithValue }) => {
    try {
      const res = await services.initService()
      return res
    } catch (err) {
      const error: any = err
      if (!error.response) {
        throw error
      }
      return rejectWithValue(error.response.data)
    }
  }
)

export const switchCompany = createAsyncThunk<
  services.SwitchCompanyResponse,
  services.SwitchCompanyParams
>(COMMON_ACTION_TYPE.SWITCH_COMPANY, async (params, { rejectWithValue }) => {
  try {
    const res = await services.switchCompanyService(params)
    return res
  } catch (err) {
    const error: any = err
    if (!error.response) {
      throw error
    }
    return rejectWithValue(error.response.data)
  }
})

export const getQuiz = createAsyncThunk<services.Quiz>(
  COMMON_ACTION_TYPE.GET_QUIZ,
  async (_, { rejectWithValue }) => {
    try {
      const res = await services.getQuizService()
      return res
    } catch (err) {
      const error: any = err
      if (!error.response) {
        throw error
      }
      return rejectWithValue(error.response.data)
    }
  }
)

export const postQuiz = createAsyncThunk<services.Quiz, services.AnswerPayload>(
  COMMON_ACTION_TYPE.POST_QUIZ,
  async (params, { rejectWithValue }) => {
    try {
      const res = await services.postQuizService(params)
      return res
    } catch (err) {
      const error: any = err
      if (!error.response) {
        throw error
      }
      return rejectWithValue(error.response.data)
    }
  }
)

export const setInitTags = createAsyncThunk<
  services.Quiz,
  services.TagAnswerPayload
>(COMMON_ACTION_TYPE.SET_INIT_TAGS, async (params, { rejectWithValue }) => {
  try {
    const res = await services.setInitTagService(params)
    return res
  } catch (err) {
    const error: any = err
    if (!error.response) {
      throw error
    }
    return rejectWithValue(error.response.data)
  }
})

export const setInitPositions = createAsyncThunk<
  services.Quiz,
  services.PositionAnswerPayload
>(COMMON_ACTION_TYPE.SET_INIT_POSITION, async (params, { rejectWithValue }) => {
  try {
    const res = await services.setInitPositionService(params)
    return res
  } catch (err) {
    const error: any = err
    if (!error.response) {
      throw error
    }
    return rejectWithValue(error.response.data)
  }
})

export const setSurvey = createAsyncThunk<
  services.Quiz,
  services.AnswerPayload
>(COMMON_ACTION_TYPE.SURVEY, async (params, { rejectWithValue }) => {
  try {
    const res = await services.surveyService(params)
    return res
  } catch (err) {
    const error: any = err
    if (!error.response) {
      throw error
    }
    return rejectWithValue(error.response.data)
  }
})
